import {
    getSsoClientId,
    getSsoKeycloakBase,
} from '../../_services/_hostingenvironments_/hostingEnvironments.js';

const STATE_KEY = 'sso_state';
const NONCE_KEY = 'sso_nonce';
const REDIRECT_URI_KEY = 'sso_redirect_uri';

export interface SsoSession {
    state: string | null;
    nonce: string | null;
    redirectUri: string | null;
}

// `state` is a CSRF token: it must come from a cryptographic source, never Math.random().
export function randomString(): string {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function buildKeycloakAuthUrl(state: string, nonce: string, redirectUri: string): string {
    const params = new URLSearchParams({
        client_id: getSsoClientId(),
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: 'openid profile',
        state: state,
        // Keycloak expects a nonce for the authorization-code flow, but nothing in our stack
        // verifies it: no id_token ever reaches the browser. It is not a check.
        nonce: nonce
    });
    return getSsoKeycloakBase() + '/auth?' + params.toString();
}

// sessionStorage throws in some privacy modes; a failure must surface as a clean error.
export function saveSsoSession(state: string, nonce: string, redirectUri: string): void {
    try {
        window.sessionStorage.setItem(STATE_KEY, state);
        window.sessionStorage.setItem(NONCE_KEY, nonce);
        window.sessionStorage.setItem(REDIRECT_URI_KEY, redirectUri);
    } catch (error) {
        console.error('No se ha podido guardar la sesión SSO:', error);
        throw error;
    }
}

export function readSsoSession(): SsoSession {
    try {
        return {
            state: window.sessionStorage.getItem(STATE_KEY),
            nonce: window.sessionStorage.getItem(NONCE_KEY),
            redirectUri: window.sessionStorage.getItem(REDIRECT_URI_KEY)
        };
    } catch (error) {
        console.error('No se ha podido leer la sesión SSO:', error);
        return { state: null, nonce: null, redirectUri: null };
    }
}

export function clearSsoSession(): void {
    try {
        window.sessionStorage.removeItem(STATE_KEY);
        window.sessionStorage.removeItem(NONCE_KEY);
        window.sessionStorage.removeItem(REDIRECT_URI_KEY);
    } catch (error) {
        console.error('No se ha podido limpiar la sesión SSO:', error);
    }
}
